import kiosks from './kiosks';

const AUTH_KEY = 'auth';
const LOGIN_TYPE = 'LOGIN_TYPE';
export const MAGIC_LINK = 'MAGIC_LINK';
export const CREDENTIALS = 'CREDENTIALS';

export function getAuth() {
  return sessionStorage.getItem(AUTH_KEY);
}

function setAuth(value) {
  sessionStorage.setItem(AUTH_KEY, value);
}

export function getLoginType() {
  return sessionStorage.getItem(LOGIN_TYPE);
}

const setLoginType = loginType => {
  sessionStorage.setItem(LOGIN_TYPE, loginType);
};

export function removeAuth() {
  sessionStorage.removeItem(AUTH_KEY);
  sessionStorage.removeItem(LOGIN_TYPE);
}

export async function login(username, password, loginType) {
  const auth = btoa(username + ':' + password);
  try {
    setLoginType(loginType);
    setAuth(auth);
    await kiosks.login();
  } catch (error) {
    removeAuth();
    throw error;
  }
}

export function logout() {
  removeAuth();
  window.location = '/';
}

export function addAuthorizationHeader(config) {
  const auth = getAuth();
  if (auth) {
    config.headers['Authorization'] = `Basic ${auth}`;
  }
  return config;
}
